import { CircleIcon } from '@icons/CircleIcon';
import { StopWatchIcon } from '@icons/StopWatchIcon';
import tw from 'tailwind-styled-components';

import { Text as Paragraph } from '../Typography';

interface IRecipeOverview {
  total: number;
  prep: number;
  bake: number;
  resting: number;
}

interface IRecipeCopy {
  total?: string;
  prep?: string;
  bake?: string;
  resting?: string;
  minutes?: string;
}

const Container = tw.div`
  flex
  my-10
`;

const Icon = tw.div`
  mr-3
  md:mr-8
`;

const InfoBlock = tw.div`
  mt-1
  md:mt-0.5
`;

const Info = tw.div`
  whitespace-nowrap
  flex
  mb-2.5
  items-center
`;

const Title = tw(Paragraph)`
  whitespace-nowrap
  mr-1
`;

const Copy = tw(Paragraph)`
  whitespace-nowrap
`;

const Dot = tw.div`
  text-xxs
  leading-none
  relative
  ml-2
  mr-3
`;

export const RecipeTimeOverview = ({
  data,
  titles,
}: {
  data: IRecipeOverview;
  titles: IRecipeCopy;
}) => (
  <Container data-test="recipe-time-overview">
    <Icon>
      <StopWatchIcon />
    </Icon>
    <InfoBlock>
      {data.total ? (
        <Info data-test="info">
          <Title tag="div" type="lead">
            {titles.total}:
          </Title>
          <Copy tag="div" type="link">
            {data.total} {titles.minutes || 'mins'}
          </Copy>
        </Info>
      ) : (
        ''
      )}
      <Info data-test="info">
        {data.prep ? (
          <>
            <Title tag="div" type="lead">
              {titles.prep}:
            </Title>
            <Copy tag="div" type="link">
              {data.prep} {titles.minutes || 'mins'}
            </Copy>
          </>
        ) : (
          ''
        )}
        {data.bake && data.prep ? (
          <Dot>
            <CircleIcon />
          </Dot>
        ) : null}
        {data.bake ? (
          <>
            <Title tag="div" type="lead">
              {titles.bake}:
            </Title>
            <Copy tag="div" type="link">
              {data.bake} {titles.minutes || 'mins'}
            </Copy>
          </>
        ) : (
          ''
        )}
      </Info>
      {data.resting ? (
        <Info data-test="info">
          <Title tag="div" type="lead">
            {titles.resting}:
          </Title>
          <Copy tag="div" type="link">
            {data.resting} {titles.minutes || 'mins'}
          </Copy>
        </Info>
      ) : (
        ''
      )}
    </InfoBlock>
  </Container>
);
